'use strict';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const SearchResult = (props) => {
	const [children, setChildren] = useState(props.children || []);

	useEffect(() => {
		if (props.children !== children) {
			setChildren(props.children);
		}
	}, [props.children, children]);

	const getStyles = (styles) => {
		let hasResults = children?.length > 0 && props.showResults;

		return {
			results: {
				display: hasResults ? 'block' : 'none',
				maxWidth: '100%',
				backgroundColor: 'rgb(255,255,255)',
				marginTop: '10px',
				marginLeft: '5px',
				border: "2px solid #ccc",
				borderRadius: ".5em",
				maxHeight: "339px",
				overflowY: "auto",
				minWidth: "306px",
				...styles
			}
		};
	};

	let styles = getStyles(props.styles);
	return (
		<div className="results" style={styles.results}>
			{props.children}
		</div>
	);
};

SearchResult.propTypes = {
	/** Show results in dropdown */
	showResults: PropTypes.bool
};

export default SearchResult;
